import { action, makeObservable, observable } from 'mobx';
import { StoreNode } from '../../store';
import { Store } from '../../store/store';

/**
 * Cross-browser, observable object for managing the visibility of the app.
 */
export class VisibilityManager
  extends StoreNode {

  readonly nodeType: 'VisibilityManager' = 'VisibilityManager';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'init' | 'handleVisibilityChange'>(this, {
      isVisible: observable,
      init: action,
      dispose: action,
      handleVisibilityChange: action,
    });

    this.init();
  }

  get rootVisibilityState(): DocumentVisibilityState {
    return document.visibilityState;
  }

  get rootIsVisible() {
    return this.rootVisibilityState === 'visible';
  }

  isVisible: boolean = false;

  /**
   * Cross-browser, non-observable getter for accessing the fullscreenElement from the document.
   * If you want an observable property, use `fullscreenElement`.
   */
  getFullscreenElement(): Element | null {
    return (
      document.fullscreenElement ??
      document.webkitFullscreenElement ??
      null);
  }

  private init() {
    document.addEventListener('visibilitychange',
      this.handleVisibilityChange);
  }

  dispose() {
    document.removeEventListener('visibilitychange',
      this.handleVisibilityChange);
    this.isDisposed = true;
  }

  private handleVisibilityChange = (_evt: Event) => {
    this.isVisible = this.rootIsVisible;
    this.emit('Change', {
      isVisible: this.isVisible 
    });
  }
}
